import { Grid } from '@mui/material';
import { FC, SetStateAction, Dispatch } from 'react';
import { FiltersLayout, FiltersButtons, SearchField } from '../../../components';

interface IManagePartClassFilter {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  setHasAppliedFilters: Dispatch<SetStateAction<boolean>>;
  hasAppliedFilters: boolean;
  setSearchValue?: (val: string) => void;
  searchValue?: string;
  handleSearch?: (val: string) => void;
  searchPlaceholder?: string;
}

export const ManagePartClassFilter: FC<IManagePartClassFilter> = ({
  isLoading,
  applyFilters,
  setHasAppliedFilters,
  hasAppliedFilters,
  handleSearch,
  searchValue,
  setSearchValue,
  searchPlaceholder
}) => {
  return (
    <FiltersLayout>
      {handleSearch && (
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <SearchField
            isDisabled={isLoading}
            placeholder={searchPlaceholder}
            handleSearch={handleSearch}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
        </Grid>
      )}

      <Grid item xs={12} md={5} xl={3}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSearchValue('');
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};
